module.exports = __webpack_public_path__ + "static/img/game1_bg1.06db4f9b.png";